import { DateChangeEvent, DatePicker } from '../../../../components/DatePicker';
import { Dialog, DialogAction } from '../../../../components/Dialog';
import { withLabels } from '../../../../components/withLabels';
import { useMessageDialogText } from '../../../../components/MessageDialog';
import { createElement, useState } from 'react';
import bundle from '../../NovaComponents-CatalogSearch-gui-icu.properties';
import { createUseTextLocalizer } from '../../../../locale/createUseTextLocalizer';
import { postfixTestId, TestIdProps } from '../../../../util/testId';
import { Flow } from '../../../../components/Layouts/Flow';

const DatePickerWithLabels = withLabels(DatePicker);
interface DateRangeSelectorDialogProps extends TestIdProps {
  onOk: (startDate: Date, endDate: Date) => void;
  onCancel: () => void;
}

const useTextLocalizer = createUseTextLocalizer(bundle);

export const DateRangeSelectorDialog = ({
  onOk,
  onCancel,
  testId,
}: DateRangeSelectorDialogProps) => {
  const localize = useTextLocalizer();
  const { CANCEL, OK } = useMessageDialogText();
  const ONE_WEEK_MS = 1000 * 60 * 60 * 24 * 7;
  const [startDate, setStartDate] = useState<Date>(new Date(Date.now() - ONE_WEEK_MS));
  const [endDate, setEndDate] = useState<Date>(new Date(Date.now()));
  const [startMaxDate, setStartMaxDate] = useState<Date>(endDate);
  const [endMinDate, setEndMinDate] = useState<Date>(startDate);

  const dateRangeDialogPrimaryAction: DialogAction = {
    text: OK,
    isDefault: true,
    disabled: false,
    onPress: () => {
      onOk(startDate, endDate);
    },
  };

  const dateRangeDialogDismissAction: DialogAction = {
    text: CANCEL,
    onPress: () => {
      onCancel();
    },
  };

  return (
    <Dialog
      resizable={false}
      size={{ width: 200 }}
      isOpen
      title={localize('datePicker.dialog.title')}
      firstAction={dateRangeDialogPrimaryAction}
      dismissAction={dateRangeDialogDismissAction}
      testId={postfixTestId(testId, 'dialog')}
    >
      <Flow orientation="vertical" spacing="m">
        <DatePickerWithLabels
          labelPosition={'top'}
          label={localize('datePicker.startDate.label')}
          value={startDate}
          maxDate={startMaxDate}
          onChange={(newDate: DateChangeEvent) => {
            if (!!newDate.value) {
              setStartDate(newDate.value);
              setEndMinDate(newDate.value);
            }
          }}
          testId={postfixTestId(testId, 'startdatepicker')}
        />
        <DatePickerWithLabels
          label={localize('datePicker.endDate.label')}
          labelPosition={'top'}
          value={endDate}
          minDate={endMinDate}
          maxDate={new Date(Date.now())}
          onChange={(newDate: DateChangeEvent) => {
            if (!!newDate.value) {
              setEndDate(newDate.value);
              setStartMaxDate(newDate.value);
            }
          }}
          testId={postfixTestId(testId, 'enddatepicker')}
        />
      </Flow>
    </Dialog>
  );
};
